import { webAuth } from "./webAuthLogin";
import axiosInstance from "./axiosInstance";

export const HeaderData = async () => {
  try {
    const headerResponse = await axiosInstance.get("/backend/product/get-categories-simple");
    return headerResponse.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return { success: false, message: error.message };
  }
};
